// Package
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    text: {
      type: String,
      required: false,
      default: "",
    },
    variant: { type: String, required: true, default: "body" },
    color: { type: String, required: false },
  },
  computed: {
    cssProps() {
      const objStyles = {
        display: {
          "--weight": "700",
          "--size": "44px",
          "--line-height": "48px",
          "--letter": "-0.02em",
          "--color": "#78909C",
        },
        h1: {
          "--weight": "700",
          "--size": "32px",
          "--line-height": "40px",
          "--letter": "-0.02em",
          "--color": " #263238",
        },
        h2: {
          "--weight": "700",
          "--size": "26px",
          "--line-height": "36px",
          "--letter": "-0.02em",
          "--color": "#455A64",
        },
        h3: {
          "--weight": "500",
          "--size": "21px",
          "--line-height": "24px",
          "--letter": "0",
          "--color": "#607D8B",
        },
        body: {
          "--weight": "400",
          "--size": "16px",
          "--line-height": "28px",
          "--letter": "0",
          "--color": "#263238",
        },
        bodyBold: {
          "--weight": "700",
          "--size": "16px",
          "--line-height": "28px",
          "--letter": "0",
          "--color": "#37474F",
        },
        tableHeader: {
          "--weight": "500",
          "--size": "16px",
          "--line-height": "20px",
          "--letter": "0",
          "--color": "#78909C",
        },
        tableValue: {
          "--weight": "400",
          "--size": "16px",
          "--line-height": "20px",
          "--letter": "0",
          "--color": "#263238",
        },
        CTA: {
          "--weight": "700",
          "--size": "18px",
          "--line-height": "24px",
          "--letter": "0",
          "--color": "#FFFFFF",
        },
        CTASmall: {
          "--weight": "500",
          "--size": "16px",
          "--line-height": "20px",
          "--letter": "0",
          "--color": "#FFFFFF",
        },
        labelBold: {
          "--weight": "700",
          "--size": "12px",
          "--line-height": "16px",
          "--letter": "0",
          "--color": "#263238",
        },
        label: {
          "--weight": "400",
          "--size": "12px",
          "--line-height": "16px",
          "--letter": "0",
          "--color": "#263238",
        },
      };
      if (this.color) objStyles[this.variant]["--color"] = this.color
      return objStyles[this.variant];
    },
  },
});
